/**
 * @file: useProductManifestItemsForSubject.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { useLocalObservable } from '@euler/utils/hooks';
import { useMemo } from 'react';

export const useProductManifestItemsForSubject = (subject: string) => {
  const { taskManager } = useTaskContext();
  const { productManifestManager } = taskManager;
  const items = useLocalObservable(productManifestManager.manifest$, undefined);
  return useMemo(
    () => items?.filter(x => x.subject === subject),
    [items, subject],
  );
};
